import React from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Hero from "components/hero/TwoColumnWithInput.js";
import SliderCard from "components/cards/ThreeColSlider.js";
// import SliderCard from "components/cards/TabCardGrid";
// import ContactUsForm from "components/forms/SimpleContactUs.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import Testimonials from "components/testimonials/TwoColumnWithImageAndProfilePictureReview";
import FeatureStats from "components/features/ThreeColCenteredStatsPrimaryBackground.js";

// images
// import Portfolio1 from "images/portfolio/portfolio1.jpg";
import Portfolio2 from "images/portfolio/portfolio2.jpg";
import Portfolio3 from "images/portfolio/portfolio3.jpg";
import Portfolio4 from "images/portfolio/portfolio4.jpg";
import mfzPortfolio from "images/portfolio/MFZ-portfolio.png";
import Client1 from "images/client1.avif";
import Client2 from "images/client2.jpeg";
import Client3 from "images/client3.avif";
import Client4 from "images/client4.avif";

const Subheading = tw.span`uppercase tracking-wider text-sm`;

export default () => (
  <AnimationRevealPage>
    <Header />
    <div>
      <Hero />

      {/* <div id="contact">
        <ContactUsForm />
      </div> */}
      <SliderCard
        heading="Popular Posts"
        cards={[
          {
            imageSrc: mfzPortfolio,
            title: "Wyatt Residency",
            description:
              "Lorem ipsum dolor sit amet, consectur dolori adipiscing elit, sed do eiusmod tempor nova incididunt ut labore et dolore magna aliqua.",
            locationText: "Rome, Italy",
            pricingText: "USD 39/Day",
            rating: "4.8",
          },
          {
            imageSrc: Portfolio2,
            title: "Soho Paradise",
            description:
              "Lorem ipsum dolor sit amet, consectur dolori adipiscing elit, sed do eiusmod tempor nova incididunt ut labore et dolore magna aliqua.",
            locationText: "Ibiza, Spain",
            pricingText: "USD 50/Day",
            rating: 4.9,
          },
          {
            imageSrc: Portfolio3,
            title: "Hotel Baja",
            description:
              "Lorem ipsum dolor sit amet, consectur dolori adipiscing elit, sed do eiusmod tempor nova incididunt ut labore et dolore magna aliqua.",
            locationText: "Palo Alto, CA",
            pricingText: "USD 19/Day",
            rating: "5.0",
          },
          {
            imageSrc: Portfolio4,
            title: "Hudak Homes",
            description:
              "Lorem ipsum dolor sit amet, consectur dolori adipiscing elit, sed do eiusmod tempor nova incididunt ut labore et dolore magna aliqua.",
            locationText: "Arizona, RAK",
            pricingText: "USD 99/Day",
            rating: 4.5,
          },
        ]}
      />
      <Testimonials
        subheading="Testimonials"
        heading={
          <>
            Our Clients <span tw="text-primary-500">Love Us.</span>
          </>
        }
        description="Here are what some of our amazing customers are saying about our service."
        testimonials={[
          {
            imageSrc:
              "https://images.unsplash.com/photo-1576678927484-cc907957088c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1024&q=80",
            profileImageSrc: Client1,
            quote:
              "We thank Codistree for the wonderful job in helping us develop our Gym member managment system. Everyone was professional, excellent and hard working. Thanks to them, we were able to achieve our goal on time, and we look forward to continue working with them in the future.",
            customerName: "Kurt Vonnegut",
            customerTitle: "CEO, MFZ Gym",
          },
          {
            imageSrc: Portfolio2,
            profileImageSrc: Client2,
            quote:
              "I would say I liked working with Codistree, They was quick to understand the job at hand, and they quickly understood the existing codebase. If I ever need any more work in full stack web development, I would definitely work with them again",
            customerName: "Rahul Kumar",
            customerTitle: "Upwork Client",
          },
          {
            imageSrc: Portfolio3,
            profileImageSrc: Client3,
            quote:
              "I would say I liked working with Codistree, They was quick to understand the job at hand, and they quickly understood the existing codebase. If I ever need any more work in full stack web development, I would definitely work with them again",
            customerName: "Maruti Sharma",
            customerTitle: "Upwork Client",
          },
          {
            imageSrc: Portfolio4,
            profileImageSrc: Client4,
            quote:
              "I would say I liked working with Codistree, They was quick to understand the job at hand, and they quickly understood the existing codebase. If I ever need any more work in full stack web development, I would definitely work with them again",
            customerName: "George Orwell",
            customerTitle: "Upwork Client",
          },
        ]}
        textOnLeft={false}
      />

      <FeatureStats
        subheading=""
        heading="Over 120 Projects Completed"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        stats={[
          {
            key: "Clients",
            value: "27+",
          },
          {
            key: "Projects",
            value: "120+",
          },
          {
            key: "Techanical Conversation",
            value: "1500+",
          },
        ]}
      />
      <TeamCardGrid subheading={<Subheading>Our Team</Subheading>} />
    </div>
    <Footer />
  </AnimationRevealPage>
);
